import { render, staticRenderFns } from "./PcfCimkek.vue?vue&type=template&id=70fd509b&"
import script from "./PcfCimkek.vue?vue&type=script&lang=js&"
export * from "./PcfCimkek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports